enum PaymentType {
    Card = 1,
    Check,
    Cash,
    Other,
}

export default PaymentType;
